import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  ACCOUNT_SETTINGS_OPEN_VALUE,
  ACCOUNT_SETTINGS_PARAM,
  setPendingAccountSettingsSource,
  withoutAccountSettingsParams,
  type AccountSettingsOpenSource,
} from '@/lib/accountSettings';

/** Opens the Account Settings modal mounted by `AccountSettingsHost`. */
export function useOpenAccountSettings(): (source: AccountSettingsOpenSource) => void {
  const [, setSearchParams] = useSearchParams();
  return useCallback((source: AccountSettingsOpenSource) => {
    setPendingAccountSettingsSource(source);
    setSearchParams((prev) => {
      const next = withoutAccountSettingsParams(prev);
      next.set(ACCOUNT_SETTINGS_PARAM, ACCOUNT_SETTINGS_OPEN_VALUE);
      return next;
    }, { replace: true });
  }, [setSearchParams]);
}
